module.exports = __webpack_public_path__ + "05_long_gold.47aabb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_long_gold.png
// module id = g+Nc
// module chunks = 0